export default __webpack_public_path__ + "static/media/hero-bg-narrow.9edfc6f7.png";